import config from '@/config/config'
import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {
    defaultShortUrl: config.DEFAULT_DOMAIN,
    defaultProtocol: 'https',
    defaultLength: 6,
    beforeUpdate: {
        defaultShortUrl: config.DEFAULT_DOMAIN,
        defaultProtocol: 'https',
        defaultLength: 6
    },
    isDisabled: true
}
const getters = {
    getBeforeUpdate: (state) => state.beforeUpdate
}
const mutations = {
    SET_DEFAULT_DATA (state, payload) {
        state.defaultShortUrl = payload.DefaultDomain
        state.defaultLength = payload.DefaultLength
        state.defaultProtocol = payload.DefaultProtocol
        state.beforeUpdate.defaultShortUrl = payload.DefaultDomain
        state.beforeUpdate.defaultLength = payload.DefaultLength
        state.beforeUpdate.defaultProtocol = payload.DefaultProtocol
    },
    UPDATE_BEFORE_DATA (state) {
        state.isDisabled = true
        state.beforeUpdate.defaultShortUrl = state.defaultShortUrl
        state.beforeUpdate.defaultLength = state.defaultLength
        state.beforeUpdate.defaultProtocol = state.defaultProtocol
    }
}
const actions = {
    async fecthDefaultSettings ({ commit }) {
        try {
            const resp = await this.$axios.post(API_PATH.setting.default.get)
            commit('SET_DEFAULT_DATA', resp.data)
        } catch (err) {
            console.log(err)
        }
    },
    async updateDefaultSetting ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.setting.default.set, payload)
            if (resp && resp.data && resp.data.displayMsg.s) {
                Toastr.success(resp.data.displayMsg.s.head, resp.data.displayMsg.s.msg)
                commit('UPDATE_BEFORE_DATA')
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
